import { QuestionSection } from '../../../../common/enums/QuestionSection';

export const getIntl = (type: QuestionSection) => {
  switch (type) {
    case QuestionSection.Questions: return {
      title: {
        id: 'survey.sectionBreak.questions.title',
        defaultMessage: 'Thanks! Please answer the following questions'
      },
      description: [
        {
          id: 'survey.sectionBreak.questions.desc',
          defaultMessage: `For any yes/no questions, please answer to best of your knowledge. 
          For any free response questions, please provide as much detail as you can. As a reminder, 
          your responses are confidential.`
        }
      ]
    };
    case QuestionSection.SoftSkills: return {
      title: {
        id: 'survey.sectionBreak.softSkills.title',
        defaultMessage: 'Thanks! Some final questions.'
      },
      description: [
        {
          id: 'survey.sectionBreak.softSkills.desc1',
          defaultMessage: `"We are going to ask you questions about {firstName}'s workplace behaviors.
          {breakingLine}{breakingLine}For each question, you should pick the answer that best describes 
          how often {firstName} exhibited the behavior described.{breakingLine}{breakingLine}Remember, try 
          to compare {firstName} to "`
        },
        {
          id: 'survey.sectionBreak.softSkills.desc2',
          defaultMessage: 'others in the same role.'
        }
      ]
    };
    default: return {
      title: {
        id: '',
        defaultMessage: ''
      },
      description: [
        {
          id: '',
          defaultMessage: ''
        }
      ]
    };
  }
};
